import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import api from '../../services/api';

export default function ShareConventionLink({ conventionId, autoGenerate = false }) {
  const [shareData, setShareData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(null);

  const generateLink = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get(`/conventions/${conventionId}/share-link`);
      setShareData(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la génération du lien.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoGenerate && conventionId) generateLink();
  }, [autoGenerate, conventionId]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareData.url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="border border-gray-200 rounded-xl p-4 bg-gray-50 mt-3">
      <h4 className="text-sm font-semibold text-gray-800 mb-1">Inviter l'entreprise à remplir</h4>
      <p className="text-xs text-gray-500 mb-3">
        Partagez ce lien ou QR code à votre tuteur en entreprise. Il pourra remplir les informations sans créer de compte.
      </p>

      {error && <p className="text-xs text-red-600 mb-2">{error}</p>}

      {!shareData ? (
        <button
          onClick={generateLink}
          disabled={loading}
          className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded-lg disabled:opacity-50 transition-colors"
        >
          {loading ? 'Génération...' : 'Générer le lien'}
        </button>
      ) : (
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <input
              type="text"
              readOnly
              value={shareData.url}
              className="flex-1 px-3 py-1.5 border border-gray-200 rounded-lg bg-white text-xs text-gray-700"
            />
            <button
              onClick={copyToClipboard}
              className="px-3 py-1.5 border border-gray-200 bg-white hover:bg-gray-50 rounded-lg text-xs shrink-0 transition-colors"
            >
              {copied ? 'Copié !' : 'Copier'}
            </button>
            <a
              href={`mailto:?subject=${encodeURIComponent('Formulaire de convention de stage')}&body=${encodeURIComponent('Bonjour,\n\nVeuillez compléter les informations de la convention de stage via le lien ci-dessous :\n\n' + shareData.url + '\n\nMerci.')}`}
              className="px-3 py-1.5 border border-blue-200 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded-lg text-xs shrink-0 transition-colors"
            >
              Envoyer par mail
            </a>
          </div>
          <div className="flex justify-center p-3 bg-white border border-gray-200 rounded-lg">
            <QRCodeSVG value={shareData.url} size={160} level="M" includeMargin={true} />
          </div>
          <p className="text-xs text-center text-gray-400">Scannez ce QR code ou copiez le lien</p>
        </div>
      )}
    </div>
  );
}
